import React from 'react';
import {translate} from "react-i18next";
import LogbookApi from "../../apis/LogbookApi";
import connect from "react-redux/es/connect/connect";
import {load} from "../../actions/logbookAction";
import Comment from "./Comment";

class Comments extends React.Component {
    state = {
        entryId: null,
        comments: [],
        addComment: false,
        addMessage: '',
        addErrors: {},
        addLoading: false
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        let newState = {};
        if (nextProps.comments && nextProps.comments !== prevState.comments) {
            newState.comments = nextProps.comments;
        }
        if (nextProps.entryId && nextProps.entryId !== prevState.entryId) {
            newState.entryId = nextProps.entryId;
        }
        return newState;
    }

    handleAddComment = (e) => {
        e.preventDefault();

        this.setState({addLoading: true, addErrors: {}});
        LogbookApi.addComment(this.state.entryId, {
            message: this.state.addMessage
        }).then((result) => {
            if (result.data.success === true) {
                this.setState({
                    addComment: false,
                    addMessage: '',
                    addErrors: {},
                    addLoading: false
                });
                this.props.load(this.props.logbook.lastUpdateCall);
            } else {
                this.setState({
                    addErrors: result.data.errors,
                    addLoading: false
                });
            }
        });
    };


    render() {
        const {t} = this.props;
        return (
            <div className="comments-container m-t-sm">
                {this.state.comments.map((comment, cI) => (
                    <Comment comment={comment} key={`cc-${this.state.entryId}-${comment.id}-${cI}`} setSearchInformation={this.props.setSearchInformation}/>
                ))}
                {this.state.addComment ? (
                    <div className="comment comment-new">
                        <form onSubmit={this.handleAddComment}>
                            <div
                                className={"form-group" + ((this.state.addErrors && this.state.addErrors.message) ? ' has-error' : '')}>
                                <label>
                                    {t('logbook.entry.comment.message')}
                                </label>
                                <textarea className="form-control" value={this.state.addMessage}
                                          onChange={(e) => this.setState({addMessage: e.target.value})}
                                          disabled={this.state.addLoading}/>
                                {(this.state.addErrors && this.state.addErrors.message) ? (
                                    <span className="help-block">
                                                {t('logbook.comment.message.error.' + this.state.addErrors.message)}
                            </span>
                                ) : null}
                            </div>
                            <div className="button-container text-right">
                                <div className="btn-group">
                                    <button type="cancel" className="btn btn-default btn-xs"
                                            onClick={() => this.setState({
                                                addComment: false,
                                                addMessage: '',
                                                addErrors: {}
                                            })}>
                                        <i className="fa fa-close m-r-xs"/>
                                        {t('default.cancel')}
                                    </button>
                                    <button type="submit" className="btn btn-xs btn-primary"
                                            disabled={this.state.addLoading}>
                                        <i className={`fa fa-${this.state.addLoading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                ) : (
                    <button type="default" className="btn btn-xs btn-default"
                            onClick={() => this.setState({addComment: true})}>
                        <i className="fa fa-plus m-r-xs"/>
                        {t('logbook.addComment')}
                    </button>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook,
    authorization: state.authorization
});

export default connect(mapStateToProps, {
    load
})(translate()(Comments));
